import styled from 'styled-components';


/*
========================================
CONTENEDOR GENERAL
========================================
*/

export const ContenedorNuevoPaciente = styled.div`
    width: 94%;
    max-width: 1050px;

    box-sizing: border-box;

    margin:
        1.5rem auto
        3rem auto;
`;


/*
========================================
ENCABEZADO
========================================
*/

export const EncabezadoNuevoPaciente = styled.div`
    margin-bottom: 1.8rem;
`;


export const TituloNuevoPaciente = styled.h2`
    margin:
        0
        0
        0.4rem
        0;

    font-size: 1.25rem;

    color: #2B2B2B;
`;


export const TextoNuevoPaciente = styled.p`
    margin: 0;

    font-size: 0.9rem;
    line-height: 1.5;

    color: #646464;
`;


/*
========================================
ELECCIÓN DE TIPO DE PACIENTE
========================================
*/

export const OpcionesNuevoPaciente = styled.div`
    display: grid;

    grid-template-columns:
        repeat(
            2,
            minmax(0, 1fr)
        );

    gap: 1rem;


    @media (max-width: 700px) {

        grid-template-columns: 1fr;
    }
`;


export const OpcionPaciente = styled.button`
    width: 100%;
    min-height: 155px;

    display: flex;
    flex-direction: column;

    align-items: flex-start;
    justify-content: center;

    box-sizing: border-box;

    padding: 1.5rem;

    border:
        1px solid
        #DDDDD8;

    border-radius: 12px;

    background-color: #FFFFFF;

    cursor: pointer;

    text-align: left;

    font-family: inherit;

    transition:
        border-color 0.15s ease,
        background-color 0.15s ease,
        box-shadow 0.15s ease;


    &:hover {

        border-color: #23AAAF;

        box-shadow:
            0
            3px
            10px
            rgba(0, 0, 0, 0.08);
    }


    &:focus-visible {

        outline:
            2px solid
            #23AAAF;

        outline-offset: 2px;
    }


    &.activa {

        border-color: #23AAAF;

        background-color: #F1FAFA;
    }
`;


export const OpcionTitulo = styled.div`
    margin-bottom: 0.5rem;

    font-size: 1rem;
    font-weight: 700;

    color: #2B2B2B;
`;


export const OpcionDescripcion = styled.div`
    font-size: 0.85rem;
    line-height: 1.45;

    color: #646464;
`;


/*
========================================
BÚSQUEDA PACIENTE EXISTENTE
========================================
*/

export const ContenedorBusquedaPaciente = styled.div`
    margin-top: 1.5rem;

    box-sizing: border-box;

    padding: 1.5rem;

    border:
        1px solid
        #E3E3DF;

    border-radius: 12px;

    background-color: #FFFFFF;
`;


export const FormBusquedaPaciente = styled.form`
    display: flex;

    align-items: flex-end;

    gap: 0.8rem;


    @media (max-width: 650px) {

        flex-direction: column;

        align-items: stretch;
    }
`;


export const GrupoCampo = styled.div`
    flex: 1;

    display: flex;
    flex-direction: column;

    gap: 0.4rem;
`;


export const LabelCampo = styled.label`
    font-size: 0.82rem;
    font-weight: 600;

    color: #2B2B2B;
`;


export const InputCampo = styled.input`
    width: 100%;
    height: 42px;

    box-sizing: border-box;

    padding:
        0
        0.8rem;

    border:
        1px solid
        #D8D8D4;

    border-radius: 8px;

    background-color: #FFFFFF;

    font-family: inherit;

    font-size: 0.9rem;

    color: #2B2B2B;

    outline: none;


    &:focus {

        border-color: #23AAAF;
    }


    &[aria-invalid="true"] {

        border-color: #D76970;
    }


    &[aria-invalid="true"]:focus {

        border-color: #D76970;
    }
`;


export const TextoErrorCampo = styled.div`
    font-size: 0.75rem;

    color: #D76970;
`;


/*
========================================
BOTONES
========================================
*/

export const BotonPrincipal = styled.button`
    min-height: 42px;

    box-sizing: border-box;

    padding:
        0
        1.2rem;

    border: none;

    border-radius: 20px;

    background-color: #23AAAF;

    color: #FFFFFF;

    font-family: inherit;

    font-size: 0.88rem;
    font-weight: 600;

    cursor: pointer;

    transition:
        opacity 0.15s ease;


    &:hover:not(:disabled) {

        opacity: 0.9;
    }


    &:focus-visible {

        outline:
            2px solid
            #23AAAF;

        outline-offset: 2px;
    }


    &:disabled {

        opacity: 0.55;

        cursor: not-allowed;
    }
`;


export const BotonSecundario = styled.button`
    min-height: 40px;

    box-sizing: border-box;

    padding:
        0
        1.1rem;

    border:
        1px solid
        #23AAAF;

    border-radius: 20px;

    background-color: #FFFFFF;

    color: #23AAAF;

    font-family: inherit;

    font-size: 0.86rem;
    font-weight: 600;

    cursor: pointer;

    transition:
        background-color 0.15s ease;


    &:hover {

        background-color: #F1FAFA;
    }


    &:focus-visible {

        outline:
            2px solid
            #23AAAF;

        outline-offset: 2px;
    }
`;


/*
========================================
RESULTADO DE BÚSQUEDA
========================================
*/

export const ResultadoBusqueda = styled.div`
    margin-top: 1.2rem;

    box-sizing: border-box;

    padding:
        1rem
        1.2rem;

    border:
        1px solid
        #E3E3DF;

    border-radius: 10px;

    background-color: #FAFAF8;

    font-size: 0.88rem;
    line-height: 1.5;

    color: #2B2B2B;
`;


export const AccionesResultado = styled.div`
    display: flex;

    gap: 0.7rem;

    flex-wrap: wrap;

    margin-top: 1rem;
`;


/*
========================================
FORMULARIO NUEVO PACIENTE
========================================
*/

export const FormularioPaciente = styled.form`
    width: 100%;

    margin-top: 1.5rem;
`;


/*
========================================
BANNER DE CAMPOS OBLIGATORIOS
========================================

Se muestra únicamente después de que el
profesional intenta crear la ficha y hay
algún error.
*/

export const BannerObligatorios = styled.div`
    position: sticky;

    top: 0.75rem;

    z-index: 5;

    display: flex;

    flex-direction: column;

    gap: 0.15rem;

    box-sizing: border-box;

    margin-bottom: 1.2rem;

    padding:
        0.9rem
        1.4rem;

    border-radius: 14px;

    background-color: #6762C6;

    color: #FFFFFF;

    box-shadow:
        0
        6px
        16px
        rgba(0, 0, 0, 0.14);
`;


export const BannerTitulo = styled.div`
    font-size: 0.9rem;

    font-weight: 800;
`;


export const BannerDetalle = styled.div`
    font-size: 0.78rem;

    font-weight: 600;

    opacity: 0.92;
`;


/*
========================================
TARJETA PRINCIPAL
========================================

A diferencia de la versión anterior,
todo el formulario pertenece a una misma
ficha visual.
*/

export const TarjetaFicha = styled.div`
    width: 100%;

    box-sizing: border-box;

    padding:
        2rem
        2.2rem;

    border:
        1.5px solid
        #69BEB8;

    border-radius: 22px;

    background-color: #FFFFFF;


    @media (max-width: 700px) {

        padding:
            1.3rem
            1rem;
    }
`;


/*
========================================
COMPATIBILIDAD
========================================

Se mantiene exportado porque puede existir
algún componente que todavía lo importe.

Visualmente utiliza el mismo criterio que
la nueva ficha.
*/

export const SeccionFormulario = styled.section`
    width: 100%;

    box-sizing: border-box;

    margin-bottom: 1rem;

    padding: 1.4rem;

    border:
        1px solid
        #E3E3DF;

    border-radius: 12px;

    background-color: #FFFFFF;
`;


/*
========================================
BLOQUES INTERNOS
========================================
*/

export const BloqueFicha = styled.section`
    width: 100%;

    box-sizing: border-box;
`;


export const EncabezadoSeccion = styled.div`
    margin-bottom: 0.8rem;
`;


export const FilaTituloSeccion = styled.div`
    display: flex;

    align-items: center;

    gap: 0.5rem;
`;


export const TituloSeccion = styled.h3`
    margin:
        0
        0
        0.35rem
        0;

    font-size: 1rem;

    font-weight: 800;

    color: #23AAAF;
`;


export const TextoSeccion = styled.p`
    margin: 0;

    font-size: 0.8rem;

    line-height: 1.45;

    color: #646464;
`;


/*
========================================
BOTÓN DE AYUDA
========================================
*/

export const BotonAyudaFormulario = styled.button`
    width: 23px;

    height: 23px;

    min-width: 23px;

    display: flex;

    align-items: center;

    justify-content: center;

    box-sizing: border-box;

    padding: 0;

    border:
        1.5px solid
        #655EE8;

    border-radius: 50%;

    background-color: #FFFFFF;

    color: #655EE8;

    font-family: inherit;

    font-size: 0.78rem;

    font-weight: 800;

    cursor: pointer;


    &:hover {

        background-color:
            #F3F1FF;
    }


    &:focus-visible {

        outline:
            2px solid
            rgba(
                101,
                94,
                232,
                0.25
            );

        outline-offset: 2px;
    }
`;


/*
========================================
GRID
========================================

Mantiene las dos columnas del diseño de
la ficha técnica.

En celular pasa a una sola columna.
*/

export const GridFormulario = styled.div`
    display: grid;

    grid-template-columns:
        repeat(
            2,
            minmax(0, 1fr)
        );

    column-gap: 2rem;


    @media (max-width: 700px) {

        grid-template-columns:
            1fr;
    }
`;


/*
========================================
CAMPO
========================================

Los campos se presentan como filas de
ficha en lugar de cajas independientes.
*/

export const CampoFormulario = styled.div`
    min-height: 46px;

    display: grid;

    grid-template-columns:
        max-content
        minmax(0, 1fr);

    align-items: center;

    column-gap: 0.5rem;

    box-sizing: border-box;

    padding:
        0.55rem
        0.25rem;

    border-bottom:
        1px solid
        #D9D9D9;


    /*
    Un campo puede ocupar toda la fila.
    */

    &[data-completo="true"] {

        grid-column:
            1 / -1;
    }


    /*
    ========================================
    OBLIGATORIO
    ========================================

    Antes de intentar guardar no lo
    mostramos como error.

    Solamente destacamos su label en
    violeta y negrita, como en la ficha
    técnica original.
    */

    &[data-obligatorio="true"] label {

        color:
            #514BBE;

        font-weight:
            800;
    }


    /*
    ========================================
    ERROR
    ========================================

    El naranja aparece solamente cuando
    existe realmente un error.
    */

    &[data-error="true"] {

        margin:
            0.3rem
            0;

        padding:
            0.45rem
            0.9rem;

        border:
            2px solid
            #E7973C;

        border-radius: 20px;

        background-color:
            #FFF4E8;
    }


    &[data-error="true"] label {

        color:
            #E7973C;

        font-weight:
            800;
    }


    /*
    Texto de error ocupa la fila completa.
    */

    > div:last-child {

        grid-column:
            1 / -1;
    }


    @media (max-width: 700px) {

        grid-template-columns:
            1fr;

        align-items:
            stretch;

        gap:
            0.2rem;
    }
`;


/*
========================================
LABEL
========================================
*/

export const LabelFormulario = styled.label`
    font-size: 0.82rem;

    font-weight: 600;

    white-space: nowrap;

    color: #2B2B2B;


    @media (max-width: 700px) {

        white-space:
            normal;
    }
`;


/*
========================================
ASTERISCO OBLIGATORIO
========================================
*/

export const Obligatorio = styled.span`
    margin-left: 0.18rem;

    color: #514BBE;

    font-weight: 800;
`;


/*
========================================
INPUT
========================================
*/

export const InputFormulario = styled.input`
    width: 100%;

    min-width: 0;

    height: 36px;

    box-sizing: border-box;

    padding:
        0
        0.65rem;

    border:
        1px solid
        #B8DEDC;

    border-radius: 7px;

    outline: none;

    background-color:
        #F3FAFA;

    font-family: inherit;

    font-size: 0.84rem;

    color: #2B2B2B;

    transition:
        border-color 0.15s ease,
        background-color 0.15s ease,
        box-shadow 0.15s ease;


    &:hover:not(:disabled) {

        border-color:
            #69BEB8;
    }


    &:focus {

        border-color:
            #23AAAF;

        background-color:
            #FFFFFF;

        box-shadow:
            0
            0
            0
            2px
            rgba(
                35,
                170,
                175,
                0.12
            );
    }


    &:disabled {

        background-color:
            #F4F4F2;

        border-color:
            #D8D8D4;

        cursor:
            not-allowed;
    }
`;


/*
========================================
SELECT
========================================
*/

export const SelectFormulario = styled.select`
    width: 100%;

    min-width: 0;

    height: 36px;

    box-sizing: border-box;

    padding:
        0
        0.65rem;

    border:
        1px solid
        #B8DEDC;

    border-radius: 7px;

    outline: none;

    background-color:
        #F3FAFA;

    font-family: inherit;

    font-size: 0.84rem;

    color: #2B2B2B;

    cursor: pointer;

    transition:
        border-color 0.15s ease,
        background-color 0.15s ease,
        box-shadow 0.15s ease;


    &:hover:not(:disabled) {

        border-color:
            #69BEB8;
    }


    &:focus {

        border-color:
            #23AAAF;

        background-color:
            #FFFFFF;

        box-shadow:
            0
            0
            0
            2px
            rgba(
                35,
                170,
                175,
                0.12
            );
    }


    &:disabled {

        background-color:
            #F4F4F2;

        border-color:
            #D8D8D4;

        cursor:
            not-allowed;
    }
`;


/*
========================================
ERROR DE CAMPO
========================================
*/

export const TextoError = styled.div`
    min-height: 14px;

    margin-top: 0.15rem;

    font-size: 0.72rem;

    font-weight: 700;

    color: #E7973C;
`;


/*
========================================
SEPARADORES
========================================
*/

export const SeparadorSeccion = styled.div`
    width: 100%;

    height: 1px;

    margin:
        1.8rem
        0;

    background-color: #D9D9D9;
`;


/*
========================================
CABECERA TUTORES
========================================
*/

export const CabeceraTutores = styled.div`
    display: grid;

    grid-template-columns:
        repeat(
            2,
            minmax(0, 1fr)
        );

    gap: 2rem;

    margin-top: 0.9rem;

    padding-bottom: 0.55rem;

    border-bottom:
        1.5px solid
        #2B2B2B;


    span {

        text-align: center;

        font-size: 0.82rem;

        font-weight: 800;

        color: #2B2B2B;
    }


    @media (max-width: 700px) {

        display: none;
    }
`;


/*
========================================
SUBTÍTULO DOMICILIO
========================================
*/

export const SubtituloDomicilio = styled.h4`
    margin:
        1.8rem
        0
        0.3rem
        0;

    font-size: 0.86rem;

    font-weight: 800;

    color: #646464;
`;


/*
========================================
ACCIONES
========================================

El botón queda visible al final de la
pantalla siguiendo el diseño de la ficha.
*/

export const AccionesFormulario = styled.div`
    position: sticky;

    bottom: 0;

    z-index: 4;

    display: flex;

    justify-content: flex-end;

    box-sizing: border-box;

    margin-top: 1.2rem;

    padding:
        1rem
        0;

    background-color:
        rgba(
            255,
            255,
            255,
            0.96
        );

    border-top:
        1px solid
        #D9D9D9;

    box-shadow:
        0
        -6px
        16px
        rgba(
            0,
            0,
            0,
            0.04
        );
`;


export const BotonGuardarPaciente = styled.button`
    min-width: 165px;

    height: 44px;

    box-sizing: border-box;

    padding:
        0
        1.6rem;

    border:
        2px solid
        #E7973C;

    border-radius: 24px;

    background-color:
        #E7973C;

    color:
        #FFFFFF;

    font-family: inherit;

    font-size: 0.9rem;

    font-weight: 800;

    cursor: pointer;

    transition:
        opacity
        0.15s ease,
        transform
        0.15s ease;


    &:hover:not(:disabled) {

        opacity: 0.92;

        transform:
            translateY(-1px);
    }


    &:focus-visible {

        outline:
            2px solid
            #E7973C;

        outline-offset:
            2px;
    }


    &:disabled {

        opacity: 0.55;

        cursor:
            not-allowed;
    }
`;